import Model from './model.js'
import Entry from './entry.js'
import Lead from './lead.js'
import Contact from './contact.js'
import Company from './company.js'
import moment from 'moment'

export default class Call extends Model {
	static _routeKey = 'call'

	_constructor() {
		if (this.lead_call !== null) {
			this.lead_call = new Lead(this.lead_call)
		}

		if (this.ai != null && this.ai.body != null && typeof this.ai.body == 'string') {
			this.ai.body = JSON.parse(this.ai.body)
		}

		if (this.belongs_type == 102) {
			this.belongs = new Contact(this.belongs)
		}

		if (this.belongs_type == 2) {
			this.belongs = new Company(this.belongs)
		}
	}

	getStatus() {
		switch (true) {
			// this.call_status == 'no-answer' && this.recording_url != null
			case this.voicemail == 1:
				return 'Voicemail'
				break
			case this.dial_call_status == 'no-answer' && this.recording_url == null:
				return 'Missed call'
				break
			case this.call_status == 'completed' || this.call_status == 'in-progress':
				return 'Answered'
				break
			default:
				return 'Ringing'
		}
	}

	timeline(user) {
		let t = this._timeline(user)
		// let c = this.getCall()

		console.log(this)

		let c = null
		let s = this.status()
		let title = (this.entry.from ? this.entry.from : 'Unknown') + ' called ' + this.entry.to
		let description = this.vue.$help.e164ToNumber(this.to)
		// let icon = 'IconOutcomingCircle' 
		let icon = s[1]
		let options = {}

		if (this.number_to_id != null) {
			title = (this.entry.from ? this.entry.from : 'Unknown') + ' received a call from ' + this.entry.to
			// icon = 'IconIncomingCircle'
			description = this.vue.$help.e164ToNumber(this.from)
		}

		if (this.getStatus() == 'Missed call') {
			title = this.number_to_id != null 
				? this.entry.to +' missed a call from ' + (this.entry.from ? this.entry.from : 'Unknown') 
				: this.entry.to +' missed a call from ' + (this.entry.from ? this.entry.from : 'Unknown')
			// icon = 'IconMissedCallCircle'
		}

		return {
			// title: 'You received a new lead from ' + new Contact(t.contact).fullName(),
			title: title,
			description: description,
			created_at: this.created_at,
			icon: icon,
			...options,
			breakdown: {
				// 'Call summary': this.ai ? this.ai.body.summary : null,
				'Call recording': this.recording_url ? this : null,
				'Call summary': this.summarized,
				'Call transcription': this.transcription_text,
				'Call duration': this.vue.$help.fmtMSS(this.recording_duration),
				'Call to': this.vue.$help.e164ToNumber(this.to),
				'Call from': this.vue.$help.e164ToNumber(this.from),
				'Call status': s[2]
				// 'Post code': this.postcodeFormatted(),
			},
		}
	}

	status() {
		switch (true) {
			case (this.call_status == 'in-progress' && this.dial_call_status == null && this.recording_status != "completed"):
				return [this.direction == 'inbound' ? 'Inbound call' : 'Outbound call', 'IconCallInProgress', 'In progress'];
			break;
			case (this.call_status == 'failed'):
				return [this.direction == 'inbound' ? 'Inbound call' : 'Outbound call', 'IconCallFailed', 'Failed'];
			break;
			case (this.getStatus() == 'Ringing'):
				return [this.direction == 'inbound' ? 'Inbound call' : 'Outbound call', 'IconCallInboundRinging', 'Ringing'];
			break;
			case (this.direction == 'inbound' && this.getStatus() == 'Answered'):
				return ['Inbound call', 'IconCallInboundAnswered', 'Answered'];
			break;
			case (this.direction == 'inbound' && this.getStatus() == 'Missed call'):
				return ['Inbound call', 'IconCallInboundNoAnswer', 'Missed call'];
			break;
			case (this.direction == 'inbound' && this.getStatus() == 'Voicemail'):
				return ['Inbound call', 'IconCallInboundVoicemail', 'Voicemail'];
			break;
			case (this.direction == 'outbound' && this.getStatus() == 'Voicemail'):
				return ['Outbound call', 'IconCallInboundVoicemail', 'Voicemail'];
			break;
			case (this.direction == 'outbound' && this.getStatus() == 'Answered'):
				return ['Outbound call', 'IconCallOutboundAnswered', 'Answered'];
			break;
			case (this.direction == 'outbound' && this.getStatus() == 'Missed call'):
				return ['Outbound call', 'IconCallOutboundNoAnswer', 'No answer'];
			break;
		}

		return ['','']
	}
}
